var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "flex flex-col pre-diag-record",
      class: { "large-mode": _vm.pageData.largeFontMode },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.pageData.activeDiagRecord.preTreatmentRecord[
                  "topTongueImg"
                ] !== null,
              expression:
                "pageData.activeDiagRecord.preTreatmentRecord['topTongueImg']!==null",
            },
          ],
          staticClass: "flex flex-col mb-10",
        },
        [
          _c("model-header", { attrs: { label: "舌诊记录" } }),
          _c("div", { staticClass: "flex flex-row justify-around mb-10" }, [
            _c("img", {
              staticClass: "tongue-img",
              attrs: {
                alt: "舌顶",
                src: _vm._f("IMG_URL")(
                  _vm.pageData.activeDiagRecord.preTreatmentRecord[
                    "topTongueImg"
                  ]
                ),
              },
            }),
          ]),
          _c("diag-describe", { attrs: { describe: _vm.tongueDesc } }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.pageData.activeDiagRecord.preTreatmentRecord["faceImg"] !==
                null,
              expression:
                "pageData.activeDiagRecord.preTreatmentRecord['faceImg']!==null",
            },
          ],
          staticClass: "flex flex-col mb-10",
        },
        [
          _c("model-header", { attrs: { label: "面诊记录" } }),
          _c("div", { staticClass: "flex flex-row justify-center mb-10" }, [
            _c("img", {
              staticClass: "face-img",
              attrs: {
                alt: "面诊",
                src: _vm._f("IMG_URL")(
                  _vm.pageData.activeDiagRecord.preTreatmentRecord["faceImg"]
                ),
              },
            }),
          ]),
          _c("diag-describe", { attrs: { describe: _vm.faceDesc } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex flex-col" },
        [
          _c("model-header", { attrs: { label: "指标" } }),
          _c("diag-describe", { attrs: { describe: _vm.bloodDesc } }),
          _c("div"),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }